'use strict'

const state = {
  routesList: [
    {
      route: {name: 'vacancy-preferences-special'},
      labelKey: 'vacancy.preferences.settings.special'
    }
  ]
}

const getters = {
  getRoutesList (state, getters, rootState, rootGetters) {
    return rootGetters['vacancy/preferences/getRoutesList'].concat(state.routesList)
  }
}

const actions = {
}

const mutations = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
